<template>
  <div>
    <div class="find-pwd-box">
      <el-form
        :inline="true"
        label-position="top"
        class="find-pwd-form"
        ref="model"
        :model="model"
        :rules="rules"
      >
        <div v-if="steup === 0" class="find-pwd-form-box">
          <el-form-item label="选择学校" prop="userNO">
            <el-select
              v-model="model.userNO"
              filterable
              placeholder="请选择学校"
              style="width: 100%; max-width: 437px"
              no-match-text="未找到匹配的数据"
            >
              <el-option
                v-for="item in schools"
                :key="item.SchoolNO"
                :label="item.SchoolName"
                :value="item.SchoolNO"
              >
              </el-option>

              <template #empty
                ><li class="el-select-dropdown__item select_li">
                  <span>{{ dataLoading }}</span>
                </li></template
              >
            </el-select>
          </el-form-item>
          <el-form-item label="绑定邮箱" prop="email">
            <div class="email-box">
              <div class="email-input">
                <el-input placeholder="输入绑定邮箱" v-model="model.email" />
              </div>
              <div class="email-btn" v-if="model.email && model.email !== ''">
                <el-button @click="SendFindPwdEmailValidCode"
                  >发送验证码</el-button
                >
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="邮箱验证码"
            v-if="model.email && model.email !== ''"
            prop="validCode"
          >
            <el-input placeholder="输入邮箱验证码" v-model="model.validCode" />
          </el-form-item>
          <el-form-item>
            <el-button class="find-pwd-btn" @click="resetPassword"
              >下一步</el-button
            >
          </el-form-item>
        </div>
        <div v-else class="find-pwd-form-box">
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              type="password"
              placeholder="输入新密码"
              v-model="model.newPassword"
              :minlength="8"
              :maxlength="16"
              show-password
            />
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              placeholder="输入确认密码"
              type="password"
              v-model="model.confirmPassword"
              :minlength="8"
              :maxlength="16"
              show-password
            />
          </el-form-item>
          <el-form-item>
            <el-button class="find-pwd-btn" @click="findPwd"
              >确认重置密码</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getSchoolList } from '../http/entrance'
import {
  SendFindPwdEmailValidCode,
  ValidFindPwdValidCode,
  FindPwd
} from '../http/user'
import { ElMessage, ElLoading } from 'element-plus'
export default {
  data() {
    return {
      steup: 0,
      model: {
        userNO: '',
        email: '',
        validCode: '',
        batchKey: '',
        newPassword: '',
        confirmPassword: ''
      },
      schools: [],
      dataLoading: '数据加载中',
      rules: {
        validCode: [
          {
            required: true,
            message: '请输入邮箱验证码',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: '请输入正确的邮箱',
            trigger: ['blur', 'change']
          }
        ],
        userNO: [
          {
            required: true,
            message: '请选择学校',
            trigger: ['blur', 'change']
          }
        ],
        newPassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          { min: 8, max: 16, message: '新密码长度在8至16位之间' }
        ],
        confirmPassword: [
          {
            required: true,
            message: '请输入确认密码',
            trigger: 'blur'
          },
          { min: 8, max: 16, message: '确认密码长度在8至16位之间' }
        ]
      }
    }
  },
  methods: {
    getSchoolList() {
      getSchoolList({}).then((res) => {
        if (res.IsSuccess) {
          this.schools = res.Models
          this.dataLoading = '暂无数据'
        }
      })
    },
    SendFindPwdEmailValidCode() {
      if (
        !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.model.email)
      ) {
        ElMessage({
          message: '请输入正确的邮箱',
          type: 'warning'
        })
        return
      }
      var loading = ElLoading.service({
        lock: true,
        text: '正在请求服务器······',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      SendFindPwdEmailValidCode(this.model)
        .then((res) => {
          loading.close()
          if (res.IsSuccess) {
            ElMessage({
              message: res.SuccessMessage,
              type: 'success'
            })
          } else {
            ElMessage({
              message: res.ErrorMessage,
              type: 'warning'
            })
          }
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    resetPassword() {
      this.$refs.model.validate((valid) => {
        if (!valid) {
          return false
        }
        ValidFindPwdValidCode(this.model).then((res) => {
          if (res.IsSuccess) {
            this.model.batchKey = res.BatchKey
            this.steup = 1
          } else {
            ElMessage({
              message: res.ErrorMessage,
              type: 'warning'
            })
          }
        })
      })
    },
    findPwd() {
      this.$refs.model.validate((valid) => {
        if (!valid) {
          return false
        }
        FindPwd(this.model).then((res) => {
          if (res.IsSuccess) {
            ElMessage({
              message: res.SuccessMessage,
              type: 'success'
            })
            this.$emit('callBack')
          } else {
            ElMessage({
              message: res.ErrorMessage,
              type: 'warning'
            })
          }
        })
      })
    }
  },
  created() {
    this.getSchoolList()
  }
}
</script>
<style scoped>
.find-pwd-box {
  border: 1px solid #e4e4e4;
  width: 450px;
  margin: 60px auto 20px auto;
  padding: 12px;
}
.find-pwd-form {
  width: 100%;
}
.find-pwd-form-box {
  width: 100%;
}
.el-form-item {
  width: 100%;
}
.email-box {
  display: flex;
}
.email-input {
  flex: 1;
}
.email-btn {
  width: 115px;
}
.find-pwd-btn {
  width: 100%;
}
</style>
